import { apiResource } from "./setup"

export const rowEnabledText = ({
  enabled,
  colorSuccess = 'success',
  colorDanger = 'danger',
  textSuccess = 'Activo',
  textDanger = 'Inactivo'
}) => {
  return <div className={`badge bg-${enabled === 1 ? colorSuccess : colorDanger}`}>
    {enabled === 1 ? textSuccess : textDanger}
  </div>
}

export const rowEnabledYesNo = ({ enabled }) => rowEnabledText({
  enabled,
  colorSuccess: 'info',
  colorDanger: 'secondary',
  textSuccess: 'Si',
  textDanger: 'No'
})

export const rowPhoto = (photo, name) => {
  if (!photo) {
    return <></>
  }
  return <a href={apiResource({
    url: photo
  })} target="_blank" rel="noreferrer">
    <img src={apiResource({
      url: photo
    })} alt={name} className="max-width-100 rounded" />
  </a>
}

// Allows to add an actions column to the table (in the first or last column)
export const addActionOnRow = ({ head, rowItem }) => {
  return [
    {
      name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: row => {
        return rowItem({
          row
        })
      }
    },
    ...head,
  ]
}